import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNote1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconNote1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5.5C3 4.11929 4.11929 3 5.5 3H18.5C19.8807 3 21 4.11929 21 5.5V15H17.5C16.1193 15 15 16.1193 15 17.5V21H5.5C4.11929 21 3 19.8807 3 18.5V5.5Z" fill="currentColor"/><Path d="M16 20.8588C16.3502 20.7358 16.6719 20.5352 16.9393 20.2678L20.2678 16.9393C20.5352 16.6719 20.7358 16.3502 20.8588 16H17.5C16.6716 16 16 16.6716 16 17.5V20.8588Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNote1;
